/**
 * @class HTML Video
 * 
 * @method constructor
 *     @param {HTMLElement} el
 * 
 * @method playVideo
 * @method pauseVideo
 * @method setToggleText
 * @method init
 *
 * Create a video player
 */

const selectors = {
    player: '.js-video-player',
    trigger: '.js-video-trigger',
    unmute: '.js-video-unmute'
}

const classes = {
    playing: 'is-playing',
    unmuted: 'is-unmuted',
    ready: 'is-ready'
}

export default class HTMLVideo {
    constructor (el) {
        this.el = el;
        this.player = el.querySelector(selectors.player);
        this.trigger = el.querySelector(selectors.trigger);
        this.unmute = el.querySelector(selectors.unmute);

        if (!this.player) return;

        this.isPlaying = false;

        this.init();
    }

    unmuteVideo () {
        this.player.muted = false;
        this.el.classList.add(classes.unmuted);
        this.isPlaying = true;

        if (this.el.dataset.controls !== 'false') {
            this.player.controls = true;
        }
    }

    playVideo () {
        this.player.play();
        this.el.classList.add(classes.playing);
        this.isPlaying = true;

        if (this.el.dataset.controls !== 'false') {
            this.player.controls = true;
        }
    }

    pauseVideo () {
        this.player.pause();
        this.el.classList.remove(classes.playing);
        this.isPlaying = false;
    }


    setToggleText () {
        this.label.innerText = this.isOpen ? this.toggle.dataset.closeText : this.toggle.dataset.openText;
    }

    init () {
        this.el.classList.add(classes.ready);

        this.player.addEventListener('play', () => {
            if (!this.el.matches(`.${classes.playing}`) && !this.el.matches(`.${classes.unmuted}`)) return
            this.isPlaying = true;
        });

        this.player.addEventListener('pause', () => {
            this.isPlaying = false;
        });

        if (this.trigger) {
            this.trigger.addEventListener('click', () => {
                this.playVideo();
            });
        }

        if (this.unmute) {
            this.unmute.addEventListener('click', () => {
                this.unmuteVideo();
            });
        }
    }
}
